<template>
  <section class="pa-2">
    <v-card class="p-1">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Suspicious Hold List</div>
        <div>
          <bread-crumb :bread-crumbs="['Suspicious Hold List']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <!-- <v-card-title>
        <v-row class="ms-1">
          <v-form ref="searchform" v-model="valid">
            <v-row class="me-1 mt-5">
              <v-col cols="12" md="3" lg="2" xs="12">
                <v-autocomplete
                  v-model="selectedCountry"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Payout Partner"
                  item-text="txt"
                  item-value="val"
                  :items="country_options"
                  :rules="countryRules"
                  @input="getPaymentMode"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" lg="2" xs="12">
                <v-autocomplete
                  v-model="selectedPayment"
                  class="rounded"
                  dense
                  outlined
                  item-text="txt"
                  item-value="val"
                  :items="method_options"
                  placeholder="Payment Mode"
                  :rules="paymentModeRules"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" lg="2" xs="12">
                <v-autocomplete
                  v-model="selectedPayment"
                  class="rounded"
                  dense
                  outlined
                  item-text="txt"
                  item-value="val"
                  :items="method_options"
                  placeholder="Location"
                  :rules="paymentModeRules"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" lg="2" xs="12">
                <v-autocomplete
                  v-model="selectedPayment"
                  class="rounded"
                  dense
                  outlined
                  item-text="txt"
                  item-value="val"
                  :items="method_options"
                  placeholder="Search By"
                  :rules="paymentModeRules"
                ></v-autocomplete>
              </v-col>
              <v-btn
                depressed
                small
                color="primary"
                class="text-capitalize mt-1 text-decoration-none"
                ><v-icon small>mdi-content-save-plus-outline</v-icon>
                View</v-btn
              >
            </v-row>
          </v-form>
        </v-row>
      </v-card-title> -->
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        dense
        :search="search"
        class="mt-2"
        :items="SuspiciosList"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn
            @click="openDialog(item)"
            depressed
            dense
            outlined
            color="success"
            rounded
            small
          >
            <v-icon small color="success font-weight-bold" class="mr-1">
              mdi mdi-check
            </v-icon>
            Release
          </v-btn>
        </template>
        <template v-slot:item.pin_no="{ item }">
          <a
            title="View Transaction Details"
            class="border-d"
            @click="viewTxn(item)"
            >{{ item.pin_no }}</a
          >
        </template>
        <template v-slot:item.collection_amount="{ item }">
          <span
            >{{ item.collection_amount }} {{ item.collection_currency }}</span
          >
        </template>
        <template v-slot:item.payout_amount="{ item }">
          <span>{{ item.payout_amount }} {{ item.payout_currency }}</span>
        </template>
        <template v-slot:item.sanction_notes="{ item }">
          <p class="error--text pb-0 mb-0">{{ item.sanction_notes }}</p>
        </template>
        <template v-slot:top>
          <!-- <v-divider class="p-0 m-0 primary--text"></v-divider> -->
          <v-row class="ms-1 me-1 mt-5">
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="me-2"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-10"
              dense
              clearable
            ></v-text-field>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <!-- delete dialog -->
    <v-dialog persistent v-model="showDialog" width="500">
      <v-card>
        <v-form ref="Addform" v-model="valid">
          <v-toolbar color="secondary" dark flat dense>
            <span>Compliance</span>
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-row class="mt-5">
              <v-col cols="12" md="12">
                <label class="my-0 rounded required">
                  Your are about release compliance transaction.Please enter
                  Notes/Remarks
                </label>
                <v-textarea
                  class="rounded"
                  v-model="remarks"
                  dense
                  outlined
                  :rules="FieldRequired('This Field')"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mb-0"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              small
              class="text-capitalize"
              @click="updateStatus('Approved')"
            >
              <v-icon small>mdi-check-circle</v-icon> Approve
            </v-btn>
            <v-btn
              depressed
              color="error"
              small
              class="text-capitalize"
              @click="updateStatus('Rejected')"
            >
              <v-icon small>mdi-close-circle</v-icon> Reject
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <OverlayPageVue :showOverlay="loader" />
  </section>
</template>
<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import { FieldRequired } from "@/utils/validation.js";
import userService from "@/services/UserService/userService.js";
// import EventBus from "@/helpers/GlobalFunctions";
import alerts from "@/mixins/alerts";
export default {
  name: "Suspicious Hold List",
  mixins: [alerts],
  data: () => {
    return {
      FieldRequired,
      loader: false,
      valid: true,
      id: null,
      search: "",
      showDialog: false,
      remarks: "",
      headers: [
        {
          text: "ID",
          value: "id",
          sortable: false,
          width: 30,
        },
        // { text: "Conformation ID", value: "conform_id", sortable: false },
        { text: "PIN No", value: "pin_no", sortable: false, width: 80 },
        {
          text: "Deposit Type",
          value: "payment_mode",
          sortable: false,
          width: 80,
        },
        {
          text: "Partner",
          value: "payout_partner",
          sortable: false,
          width: 110,
        },
        { text: "Sender Name", value: "sender_name", sortable: false },
        { text: "Receiver Name", value: "receiver_name", sortable: false },
        {
          text: "Channel Partner",
          value: "sending_partner",
          sortable: false,
          width: 110,
        },
        {
          text: "Txn Date",
          value: "transaction_date",
          sortable: false,
          width: 110,
        },
        { text: "Collection Amt", value: "collection_amount", sortable: false },
        { text: "Payout Amt", value: "payout_amount", sortable: false },
        {
          text: "Susp. Notes",
          value: "sanction_notes",
          sortable: false,
          width: 250,
        },
        // { text: "Actions", value: "actions", sortable: false },
        // { text: "Deposit Type", value: "account_type", sortable: false  },
      ],
      SuspiciosList: [],
    };
  },
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  mounted() {
    this.getcomplianceHold();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.SuspiciosList) {
        this.exportToExcel(this.headers, this.SuspiciosList, "Suspicios List");
      }
    },
    openDialog() {
      this.showDialog = true;
    },
    AddChip() {
      return {
        title: "Suspicious Details",
        path: "/suspiciousHoldDetails",
        close: true,
      };
    },
    viewTxn(item) {
      this.$router.push({
        name: "Suspicious Details",
        query: { id: item.id, pin_no: item.pin_no },
      });
      // EventBus.$emit("custom-event", {
      //   title: "Suspicious Details",
      //   path: null,
      //   close: true,
      // });
    },
    closeDialog() {
      this.showDialog = false;
      this.$refs.Addform.resetValidation();
    },
    onSubmitFor() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.bankDetails.bank_id) {
          this.update();
        } else {
          this.save();
        }
      }
    },
    async getcomplianceHold() {
      this.loader = true;
      try {
        const response = await userService.getcomplianceHold({});
        if (response.status === 200) {
          this.SuspiciosList = response.data.data;
          this.stoploader();
        }
        console.log("countryOptions", this.SuspiciosList);
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.SuspiciosList = [];
      }
    },

    deleteItem(item) {
      this.dialogDelete = true;
      this.deleteId = item.channel_id;
    },
    async deleteItemConfirm() {},
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
